/**
 * LocaleEvent
 * Created by raul on 10/22/14.
 */
module media.hrratings.events {
    export class LocaleEvent {
        static LOCALE_READY:string = "LocaleEvent.locale_ready";
    }
}